var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            var DateHelper = /** @class */ (function () {
                function DateHelper() {
                }
                DateHelper.parseDatesFromWCFInObject = function (obj) {
                    if (typeof obj == "object") {
                        _.each(obj, function (avalue, akey) {
                            var cr = DateHelper.parseDatesFromWCFInObject(avalue);
                            if (cr) {
                                obj[akey] = cr;
                            }
                        });
                    }
                    else if (typeof obj == "string") {
                        return DateHelper.parseDateFromWcf(obj);
                    }
                    return obj;
                };
                DateHelper.parseDateFromWcf = function (date) {
                    if ((date instanceof Date)) {
                        return date;
                    }
                    else if (typeof date == "string" && date.indexOf("/Date(") >= 0) {
                        var dateWithOffsetRegExp = /^\/Date\((.*\d)([+-])(\d\d)(\d\d)\)\/$/;
                        var dateRegExp = /^\/Date\((.*\d)\)\/$/;
                        var dateVars = dateWithOffsetRegExp.exec(date);
                        var timestamp = 0;
                        if (dateVars) {
                            timestamp = parseInt(dateVars[1], 10);
                            var sign = dateVars[2] === '-' ? (-1) : 1;
                            var offsetMiliSeconds = ((parseInt(dateVars[3]) * 60) + (parseInt(dateVars[4]))) * 60000;
                            timestamp = timestamp + (sign * offsetMiliSeconds);
                        }
                        else {
                            dateVars = dateRegExp.exec(date);
                            timestamp = parseInt(dateVars[1], 10);
                        }
                        var m = moment.utc(timestamp);
                        var newDate = new Date(m.year(), m.month(), parseInt(m.format('DD')), m.hour(), m.minutes(), m.seconds(), 0);
                        return newDate;
                    }
                    return date;
                };
                DateHelper.parseDatesFromObjectToWCF = function (obj, serverTimezoneOffset) {
                    var reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
                    if (obj instanceof Date) {
                        return DateHelper.parseDateToWcf(obj, serverTimezoneOffset);
                    }
                    else if (angular.isString(obj) && reISO.exec(obj)) { // Converts a JSON Date string format into Date format
                        return DateHelper.parseDateToWcf(new Date(obj), serverTimezoneOffset);
                    }
                    else if (typeof obj == "object") {
                        _.each(obj, function (avalue, akey) {
                            var cr = DateHelper.parseDatesFromObjectToWCF(avalue, serverTimezoneOffset);
                            if (cr) {
                                obj[akey] = cr;
                            }
                        });
                    }
                    return obj;
                };
                DateHelper.parseDateToWcf = function (date, serverTimezoneOffset) {
                    var clientTimezonOffset = (-1) * new Date().getTimezoneOffset();
                    var timestamp = date.getTime() + (clientTimezonOffset - serverTimezoneOffset) * 60000;
                    var wcfDate = '/Date(' + timestamp + '+0000)/'; // returns local time
                    return wcfDate;
                };
                DateHelper.addBusinessDays = function (startingDate, daysToAdd, nonWorkingDays) {
                    var newDate = new Date(startingDate.valueOf()), businessDaysLeft, isWeekend, direction;
                    direction = daysToAdd > 0 ? 1 : -1;
                    businessDaysLeft = Math.abs(daysToAdd);
                    while (businessDaysLeft) {
                        newDate.setDate(newDate.getDate() + direction);
                        //isWeekend = newDate.getDay() in { 0: 'Sunday', 6: 'Saturday' };
                        for (var i = 0; i < nonWorkingDays.length; i++) {
                            if (newDate.getMonth() == this.parseDateFromWcf(nonWorkingDays[i]).getMonth())
                                if (newDate.getDate() == this.parseDateFromWcf(nonWorkingDays[i]).getDate()) {
                                    isWeekend = true;
                                    break;
                                }
                            isWeekend = false;
                        }
                        if (!isWeekend) {
                            businessDaysLeft--;
                        }
                    }
                    return newDate;
                };
                // this method converts dates back to Date objects after parsing with parseDateToWcf()
                DateHelper.parseDateBackFromWcf = function (date, serverTimezoneOffset) {
                    if (typeof date == "string" && date.indexOf("/Date(") >= 0) {
                        var dateWithOffsetRegExp = /^\/Date\((.*\d)([+-])(\d\d)(\d\d)\)\/$/;
                        var dateRegExp = /^\/Date\((.*\d)\)\/$/;
                        var dateVars = dateWithOffsetRegExp.exec(date);
                        var timestamp = 0;
                        var clientTimezonOffset = (-1) * new Date().getTimezoneOffset();
                        if (!dateVars) {
                            dateVars = dateRegExp.exec(date);
                        }
                        timestamp = parseInt(dateVars[1], 10) - (clientTimezonOffset - serverTimezoneOffset) * 60000;
                        var newDate = new Date(timestamp);
                        return newDate;
                    }
                    return date;
                };
                return DateHelper;
            }());
            Helpers.DateHelper = DateHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=datehelper.js.map